import React from 'react'
import '../styles/plus.css'

const Testimonials = () => {
  return (
      <div class="testimonial">
          <div class="bsmall-container">
              <div class="brow">
                  <div class="col-3">
                      <i class="fa fa-quote-left"></i>
                      <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          Perferendis, quae molestias error id est voluptatibus quos amet
                          numquam aspernatur nam cumque ullam? Veritatis eveniet et, maxime
                          eaque soluta quas modi.
                      </p>
                      <div class="rating">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                      </div>
                      <img src="https://i.ibb.co/zfXD2Tx/user-1.png" alt="" />
                      <h3>Marta W.</h3>
                  </div>

                  <div class="col-3">
                      <i class="fa fa-quote-left"></i>
                      <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          Perferendis, quae molestias error id est voluptatibus quos amet
                          numquam aspernatur nam cumque ullam? Veritatis eveniet et, maxime
                          eaque soluta quas modi.
                      </p>
                      <div class="rating">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                      </div>
                      <img src="https://i.ibb.co/FVyK1KM/user-2.png" alt="" />
                      <h3>Rula P.</h3>
                  </div>

                  <div class="col-3">
                      <i class="fa fa-quote-left"></i>
                      <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing elit.
                          Perferendis, quae molestias error id est voluptatibus quos amet
                          numquam aspernatur nam cumque ullam? Veritatis eveniet et, maxime
                          eaque soluta quas modi.
                      </p>
                      <div class="rating">
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                          <i class="fa fa-star"></i>
                      </div>
                      <img src="https://i.ibb.co/jZ3tQqK/user-3.png" alt="" />
                      <h3>Vika Z.</h3>
                  </div>
              </div>
          </div>
      </div>
  )
}

export default Testimonials